module.exports = "/_next/static/chromiums/twitter-512x512-products-passionfruit-mango-lip-balm-1b35f1f6266968bca8b6578a82ba4f68.jpg";